import { createContext, useContext } from 'react';

import type { MobileContextState } from './types';

const MobileContext = createContext<Nullable<MobileContextState>>(null);

const useMobileContext = () => {
  const context = useContext(MobileContext);
  if (!context) {
    throw new Error('useMobileContext must be used within a MobileProvider');
  }
  return context;
};

export { MobileContext, useMobileContext };
